import Image from 'next/image';
import { CDN2 } from '@/helpers/api';
import Link from 'next/link';
import { Button } from 'antd';

export default function LinksSection() {
  return (
    <div className="w-full bg-gray-50">
      <div className="px-4 md:px-32 xl:px-4 mx-auto w-full flex flex-col justify-between items-center max-w-7xl py-16">
        <h2 className="text-3xl font-bold md:hidden mb-6"
        >Become a Parking Partner</h2>
        <div className="flex-1 flex flex-col-reverse md:flex-row items-center w-full md:gap-x-6">
          <div className="flex-1 flex flex-col items-center md:items-start space-y-6">
            <h2 className="text-3xl font-bold hidden md:block"
            >Become a Parking Partner</h2>
            <p className="text-base md:text-lg text-center md:text-left">
              <strong>Boost your lot’s visibility and earnings</strong> by joining our national parking network.
              <strong> We drive the bookings</strong> — <strong>you provide the space</strong>.
              Our system makes filling your spaces effortless, bringing you <strong>more customers, more income, and more time</strong> to focus on your business.
            </p>
            <Link href="/onboarding">
              <Button type="primary">
                Get Started
              </Button>
            </Link>
          </div>
          <div className="flex-1 flex justify-end">
            <Image
              src={CDN2() + '/staticmyapp/partnerus/PartnerOnboarding.png'}
              alt="Partner Onboarding"
              width="448"
              height="448"
              quality={100}
              className="w-40 md:w-[448px] border rounded-lg h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
